/**
 * Party player/queue title presentation.
 *
 * Artist metadata is currently unreliable (host/adder names and channel
 * text can appear as artist). Until catalog work restores structured
 * artist relationships, these surfaces show the raw provider title only.
 */
export function displayTrackTitle(track) {
  return typeof track?.title === 'string' ? track.title.trim() : '';
}

export function formatTrackTitleLine(track) {
  return displayTrackTitle(track);
}
